import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["form", "fileInput", "templateLink"]

  connect() {
    this.element.addEventListener('show.bs.modal', (event) => {
      const button = event.relatedTarget
      if (button && button.dataset.organizationId) {
        const organizationId = button.dataset.organizationId
        this.updateFormAction(organizationId)
      }
    })

    this.element.addEventListener('hidden.bs.modal', () => {
      this.resetForm()
    })
  }

  updateFormAction(organizationId) {
    const formAction = `/admin/organizations/${organizationId}/users_bulk/apply_import`
    this.formTarget.action = formAction
    this.formTarget.setAttribute('action', formAction)

    // The hidden authenticity_token is a per-form CSRF token bound to the
    // original action ('#'). Since we rewrite the action above, that token no
    // longer matches and Rails raises InvalidAuthenticityToken. Replace it with
    // the global (action-independent) token from the csrf-token meta tag.
    this.syncCsrfToken()

    const templateUrl = `/admin/organizations/${organizationId}/users_bulk/template`
    this.templateLinkTarget.href = templateUrl
    this.templateLinkTarget.setAttribute('href', templateUrl)

    this.fileInputTarget.value = ''
  }

  syncCsrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    const tokenInput = this.formTarget.querySelector('input[name="authenticity_token"]')
    if (meta && tokenInput) tokenInput.value = meta.content
  }

  resetForm() {
    this.formTarget.action = '#'
    this.templateLinkTarget.href = '#'
    this.fileInputTarget.value = ''
  }
}

